<section class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="section-title text-center mb-4 pb-2">
          <h4 class="title mb-4">Our Agents</h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
        <div class="card blog rounded border-0 shadow overflow-hidden">
          <div class="card-body content">
            <h6 class="color-brand">Brunei Darussalam</h6>
            <a class="title text-dark h5">Maji Remittance Services</a>
            <p class="text-muted mt-2">
              Unit No 01-33A Ground Floor Seria Plaza, Kuala Belait KB1133. BSB, Brunei Darussalam.
            </p>
            <ul class="list-unstyled d-flex justify-content-between border-top mt-3 pt-3 mb-0">
              <li class="text-muted small"><i class='bx bxs-phone'></i> +673 3224560</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
        <div class="card blog rounded border-0 shadow overflow-hidden">
          <div class="card-body content">
            <h6 class="color-brand">Brunei Darussalam</h6>
            <a class="title text-dark h5">Wadi Shazana Remittance</a>
            <p class="text-muted mt-2">
              Darussalam Complex, Unit 15, 2-3, Jalan McArthur, Bandar Seri Begawan BS8711, Brunei Darussalam.
            </p>
            <ul class="list-unstyled d-flex justify-content-between border-top mt-3 pt-3 mb-0">
              <li class="text-muted small"><i class='bx bxs-phone'></i> +673 2223538</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2">
        <div class="card blog rounded border-0 shadow overflow-hidden">
          <div class="card-body content">
            <h6 class="color-brand">Brunei Darussalam</h6>
            <a class="title text-dark h5">K & H  Remittance Services</a>
            <p class="text-muted mt-2">
              No.5, Bangunan Haji Sulaiman Jalan Tutong, Kampong Sengkurong, BG1121 BSB, Brunei Darussalam
            </p>
            <ul class="list-unstyled d-flex justify-content-between border-top mt-3 pt-3 mb-0">
              <li class="text-muted small"><i class='bx bxs-phone'></i> +673 4261437</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-4 pt-2">
        <ul class="pagination justify-content-center mb-0">
          <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Previous">Prev</a></li>
          <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
          <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
          <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
          <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Next">Next</a></li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="section bg-light" style="padding-top: 50px !important; padding-bottom: 50px !important;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title">
          <h4 class="title ">
            Became our agent ?
          </h4>
          <div class="mt-4 pt-2">
            <a (click)="routeHelper.navigated('register-agent')" class="btn btn-brand">Register Now</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
